import React from 'react';
import { CtaButton } from './CtaButton';
import { PRECIO_LARGO } from '../data/content';
export function FinalSection() {
  return <section className="w-full bg-verde py-14 text-white sm:py-16 lg:py-20" aria-labelledby="cierre" data-id="element-42" data-mp="3c2lqi2swqkjt">
      <div className="mx-auto w-full max-w-3xl px-5 text-center sm:px-8" data-id="element-43" data-mp="2y2ueg7lybe8g">
        <h2 id="cierre" className="font-display text-3xl font-extrabold leading-[1.1] tracking-tight sm:text-4xl lg:text-[2.8rem]" data-id="element-44" data-mp="331e52lbhpe75">
          La próxima vez que mires el total en la caja…
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-white/85 sm:text-xl" data-id="element-45" data-mp="2t5kie94244bn">
          No queremos que te preguntes dónde se fue tu plata. Queremos que sepas que antes de
          comprar hiciste todo lo posible para pagar mejor.
        </p>

        <div className="mx-auto mt-9 max-w-md" data-id="element-46" data-mp="25ef4hzhofm3z">
          <CtaButton label="Quiero hacer rendir más mi plata" variant="light" data-id="element-47" data-mp="25grt2vhxwuq0" />
          <p className="mt-4 font-mono text-lg font-bold" data-id="element-48" data-mp="2ad8kpzoclr7u">{PRECIO_LARGO}</p>
          <p className="mt-1 text-sm text-white/70" data-id="element-49" data-mp="2wd23d820qlfr">Pago único · Acceso inmediato</p>
        </div>
      </div>
    </section>;
}